import { ref } from '@vue/composition-api'
import store from '@/store'

export default function useWorkplaceLaunch(refetchData) {
  const loading = ref(false)
  const workplaceLaunchModal = ref(null)

  const workplaceLaunchMode = ref({
    workplace_name: null,
    workplace_id: null,
    physician_duty_launch_mode: null,
  })

  const launchModeOptions = [
    { label: 'IMEDIATO', value: 'imediato' },
    { label: 'Integração', value: 'integration' },
    { label: 'IMEDIATO/Integração', value: 'imediato_integration' },
  ]

  function show(workplace) {
    workplaceLaunchMode.value.workplace_name = workplace.name
    workplaceLaunchMode.value.workplace_id = workplace.id
    const option = launchModeOptions.find(({ value }) => value === workplace.physician_duty_launch_mode)
    workplaceLaunchMode.value.physician_duty_launch_mode = option
    workplaceLaunchModal.value.show()
  }

  function editLaunchMode() {
    loading.value = true
    const payload = {
      workplace_id: workplaceLaunchMode.value.workplace_id,
      physician_duty_launch_mode: workplaceLaunchMode.value.physician_duty_launch_mode.value,
    }
    store.dispatch('app-institution/updateLaunchMode', payload)
      .then(() => {
        refetchData()
        loading.value = false
        workplaceLaunchModal.value.hide()
      }).catch(() => {
        loading.value = false
      })
  }

  return {
    loading,
    workplaceLaunchModal,
    workplaceLaunchMode,
    launchModeOptions,
    show,
    editLaunchMode,
  }
}
